export default "__VITE_ASSET__c72ba7d1__"